module.exports = __webpack_public_path__ + "img/title6.4c409f67.png";